/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

class RPOCompareFromVBFilesforBuildID {
    rposInFile1Only: Array<String> ;
    rposInFile2Only: Array<String> ;
    rposInBoth: Array<String> ;
}

export class VehicleBuildCompare {
    constructor(body: any) {
        this.buildIdToRpoCompareMap = new Map();
        const rpoMap = body.buildIdToRpoCompareMap;
        for (const buildId of Object.keys(rpoMap)) {
            const rpoCompare = new RPOCompareFromVBFilesforBuildID();
            rpoCompare.rposInFile1Only = rpoMap[buildId].rposInFile1Only;
            rpoCompare.rposInFile2Only = rpoMap[buildId].rposInFile2Only;
            rpoCompare.rposInBoth = rpoMap[buildId].rposInBoth;
            this.buildIdToRpoCompareMap.set(buildId, rpoCompare);
        }
    }

    buildIdToRpoCompareMap: Map<string, RPOCompareFromVBFilesforBuildID>;

    transformDataForGrid() {
        // convert this object with a map of sets into rows of data for the grid
        const rows = [];
        for (const buildId of this.buildIdToRpoCompareMap.keys()) {
            const rpoCompare = this.buildIdToRpoCompareMap.get(buildId);
            rows.push({
                buildId: buildId,
                rposInFile1Only: rpoCompare.rposInFile1Only,
                rposInFile2Only: rpoCompare.rposInFile2Only,
                rposInBoth: rpoCompare.rposInBoth,
                inBothCount: rpoCompare.rposInBoth.length,
                diffCount: rpoCompare.rposInFile1Only.length + rpoCompare.rposInFile2Only.length
            });
        }
        return rows;
    }
}
